__webpack_require__.p = "/games/keno/";